import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useApp } from '../../contexts/AppContext';
import Header from './Header';
import Sidebar from './Sidebar';
import Breadcrumbs from './Breadcrumbs';
import NotificationContainer from './NotificationContainer';

const MainLayout = ({ children }) => {
  const { user } = useAuth();
  const { sidebarOpen, closeSidebar } = useApp();
  const [activeSection, setActiveSection] = useState('dashboard');

  return (
    <div className="h-screen flex flex-col bg-gray-50 overflow-hidden">
      {/* Header - Fixed at top */}
      <Header />

      <div className="flex flex-1 overflow-hidden">
        {/* Sidebar - Fixed at left */}
        <Sidebar
          activeSection={activeSection}
          setActiveSection={setActiveSection}
        />

        {/* Main Content - Scrollable */}
        <div className="flex-1 flex flex-col overflow-hidden">
          {/* Breadcrumbs - Fixed */}
          <Breadcrumbs />

          {/* Page Content - Scrollable */}
          <main className="flex-1 overflow-y-auto p-6">
            <div className="max-w-7xl mx-auto">
              {children}
            </div>
          </main>
        </div>
      </div>

      {/* Mobile sidebar overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={closeSidebar}
        />
      )}

      {/* Notification Container */}
      <NotificationContainer />
    </div>
  );
};

export default MainLayout;